import i18n from '@/i18n.js'
import log from 'loglevel'
import store from '@/store/index.js'
import { alert } from '@/alert.js'

export function useHandleApiError() {
  /**
   * APIエラーをアラート表示
   * @param {Error|Response|String} error エラー
   * @returns {Promise} Sweetalert2.fireの実行結果で解決するPromise
   */
  const showApiError = async (error) => {
    let text
    if (error instanceof Response) {
      const json = await error.clone().json()
      text = json.message
    } else if (error.message) {
      text = error.message
    } else {
      text = error
    }

    return await alert.fire({
      icon: 'error',
      title: i18n.t('useHandleApiError.message.error'),
      text,
    })
  }

  /**
   * APIエラー処理
   * @param {Error|Response|String} error エラー
   * @param {Function} [callback=showApiError] handle後のcallback nullを渡すと何もせずに解決する
   * @param {boolean} [forceCallback=false] いかなる場合もcallbackを実行する場合はtrue
   * @returns {Promise} callback実行結果で解決するPromise
   */
  const handleApiError = async (
    error,
    callback = showApiError,
    forceCallback = false
  ) => {
    if (error instanceof Error) {
      // 通信障害などの場合
      log.error(error.message)
    } else if (error instanceof Response) {
      // HTTPレスポンスが成功ではない場合
      store.commit('setErrorCode', error.status)

      // エラーログ出力
      const json = await error.clone().json()
      log.error(error.status, json.message, json.errors)

      // 401(認証エラー)のときはrootのエラー表示に任せる
      if (error.status === 401 && !forceCallback) return
    } else if (error) {
      log.error(error)
    }
    return callback && callback(error)
  }

  /**
   * 認証切れアラートを表示する
   * @returns {Boolean} ユーザーのボタンプレス結果
   */
  const showAuthenticationFailedAlert = async () => {
    const result = await alert.fire({
      icon: 'error',
      title: i18n.t('useHandleApiError.message.authenticationFailed'),
      text: i18n.t('useHandleApiError.message.reLoginRequired'),
      confirmButtonText: i18n.t('useHandleApiError.action.goToLogin'),
      allowOutsideClick: false,
      allowEscapeKey: false,
    })
    return result.isConfirmed
  }

  return {
    handleApiError,
    showApiError,
    showAuthenticationFailedAlert,
  }
}
